import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetPageTypeActionType, TSetPageType } from './types';
import { ISettings } from '../../../types/settings';

export const setPageType: (type: ISettings['pageType']) => TSetPageType = actionGenerator<
  ESetPageTypeActionType.Set,
  ISettings['pageType']
>(ESetPageTypeActionType.Set);
